import {
  type CSSProperties,
  memo,
  useState,
} from 'react';

import {
  GoogleMap,
  StandaloneSearchBox,
  LoadScript,
  Marker,
} from '@react-google-maps/api';

const containerStyle = {
  width: '600px',
  height: '400px',
};

// Location of tradesun: 2196 Carmel Valley Rd, Del Mar, CA 92014, USA
const initialCenter = {
  lat: 32.933243,
  lng: -117.256939,
};

const inputStyle: CSSProperties = {
  boxSizing: 'border-box',
  border: '1px solid transparent',
  width: '240px',
  height: '39px',
  padding: '0 12px',
  borderRadius: '3px',
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
  fontSize: '14px',
  outline: 'none',
  textOverflow: 'ellipses',
  position: 'absolute',
  top: '10px',
  left: '200px',
};

let searchBox: google.maps.places.SearchBox | null = null;

interface IProps {
  disabled?: boolean;
  onChangePosition: (lat: number, lng: number) => void;
}

function GoogleMapComponent(props: IProps) {
  const { onChangePosition, disabled } = props;
  const [center, setCenter] = useState<{lat: number, lng: number}>(initialCenter);
  const [point, setPoint]= useState<{lat: number, lng: number}>();
  const [zoom, setZoom] = useState(5);
  const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY || '';

  const onLoad = (ref: google.maps.places.SearchBox) => searchBox = ref;
  const handlePlacesChanged = () => {
    if (searchBox) {
      const places = searchBox.getPlaces();
      const place = places?.length ? places[0] : null;
      if (place) {
        const lat = place?.geometry?.location?.lat();
        const lng = place?.geometry?.location?.lng();
        if (lat !== undefined && lng !== undefined) {
          onChangePosition(lat, lng);
          setCenter({
            lat, lng
          });
          setPoint({
            lat, lng
          });
          setZoom(10);
        }
      }
    }
  };

  const handleClick = (e: google.maps.MapMouseEvent) => {
    if (disabled) {
      return;
    }
    const lat = e?.latLng?.lat();
    const lng = e?.latLng?.lng();
    setPoint(center);
    if (lat !== undefined && lng !== undefined) {
      onChangePosition(lat, lng);
      setPoint({
        lat, lng
      });
    }
  };

  return (
    <LoadScript
      libraries={['places']}
      googleMapsApiKey={googleApiKey}
    >
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
        onClick={handleClick}
      >
        <StandaloneSearchBox
          onLoad={onLoad}
          onPlacesChanged={handlePlacesChanged}
        >
          <input
            disabled={disabled}
            type='text'
            placeholder='Type to search global address'
            style={inputStyle}
          />
        </StandaloneSearchBox>
        { /* Child components, such as markers, info windows, etc. */ }
        <>
          {point && (
            <Marker
              icon={{
                path:
                  'M8 12l-4.7023 2.4721.898-5.236L.3916 5.5279l5.2574-.764L8 0l2.3511 4.764 5.2574.7639-3.8043 3.7082.898 5.236z',
                fillColor: 'yellow',
                fillOpacity: 0.9,
                scale: 2,
                strokeColor: 'origin',
                strokeWeight: 2,
              }}
              position={point}
            />
          )}
        </>
      </GoogleMap>
    </LoadScript>
  );
}

export default memo(GoogleMapComponent);
